import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentTypesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAppointmentTypesQuery = {
  __typename?: "Query";
  getAppointmentTypes: Array<{
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    duration: number;
    deletedAt: string | null;
    staff: Array<{
      __typename?: "Staff";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
    } | null>;
  }>;
};

export type AppointmentTypeRowFragment = {
  __typename?: "AppointmentType";
  uuid: string;
  name: string;
  duration: number;
  deletedAt: string | null;
  staff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  } | null>;
};

export type GetStaffQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetStaffQuery = {
  __typename?: "Query";
  getStaff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
    payRates: Array<{
      __typename?: "PayRate";
      uuid: string;
      rateType: Types.RateType;
      value: number;
      appointmentType: {
        __typename?: "AppointmentType";
        uuid: string;
        name: string;
        duration: number;
      } | null;
    } | null>;
    appointmentTypes: Array<{
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      duration: number;
      deletedAt: string | null;
    } | null>;
  } | null>;
};

export type StaffRowFragment = {
  __typename?: "Staff";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
  payRates: Array<{
    __typename?: "PayRate";
    uuid: string;
    rateType: Types.RateType;
    value: number;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      duration: number;
    } | null;
  } | null>;
  appointmentTypes: Array<{
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    duration: number;
    deletedAt: string | null;
  } | null>;
};

export type GetPayRatesQueryVariables = Types.Exact<{
  staffUuid?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetPayRatesQuery = {
  __typename?: "Query";
  getPayRates: Array<{
    __typename?: "PayRate";
    uuid: string;
    appointmentTypeUuid: string | null;
    staffUuid: string | null;
    rateType: Types.RateType;
    value: number;
  } | null>;
};

export type PayRateRowFragment = {
  __typename?: "PayRate";
  uuid: string;
  appointmentTypeUuid: string | null;
  staffUuid: string | null;
  rateType: Types.RateType;
  value: number;
};

export type CreatePayRateMutationVariables = Types.Exact<{
  input: Types.CreatePayRateInput;
}>;

export type CreatePayRateMutation = {
  __typename?: "Mutation";
  createPayRate: { __typename?: "PayRate"; uuid: string };
};

export type UpdatePayRateMutationVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
  input: Types.UpdatePayRateInput;
}>;

export type UpdatePayRateMutation = {
  __typename?: "Mutation";
  updatePayRate: { __typename?: "PayRate"; uuid: string };
};

export type DeletePayRateMutationVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type DeletePayRateMutation = {
  __typename?: "Mutation";
  deletePayRate: { __typename?: "PayRate"; uuid: string };
};

export const AppointmentTypeRowFragmentDoc = gql`
  fragment AppointmentTypeRow on AppointmentType {
    uuid
    name
    duration
    deletedAt
    staff {
      userUuid
      firstName
      lastName
    }
  }
`;
export const StaffRowFragmentDoc = gql`
  fragment StaffRow on Staff {
    userUuid
    firstName
    lastName
    payRates {
      uuid
      rateType
      value
      appointmentType {
        uuid
        name
        duration
      }
    }
    appointmentTypes {
      uuid
      name
      duration
      deletedAt
    }
  }
`;
export const PayRateRowFragmentDoc = gql`
  fragment PayRateRow on PayRate {
    uuid
    appointmentTypeUuid
    staffUuid
    rateType
    value
  }
`;
export const GetAppointmentTypesDocument = gql`
  query GetAppointmentTypes {
    getAppointmentTypes {
      ...AppointmentTypeRow
    }
  }
  ${AppointmentTypeRowFragmentDoc}
`;

/**
 * __useGetAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppointmentTypesQuery,
    GetAppointmentTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentTypesQuery,
    GetAppointmentTypesQueryVariables
  >(GetAppointmentTypesDocument, options);
}
export function useGetAppointmentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentTypesQuery,
    GetAppointmentTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentTypesQuery,
    GetAppointmentTypesQueryVariables
  >(GetAppointmentTypesDocument, options);
}
export type GetAppointmentTypesQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesQuery
>;
export type GetAppointmentTypesLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesLazyQuery
>;
export type GetAppointmentTypesQueryResult = Apollo.QueryResult<
  GetAppointmentTypesQuery,
  GetAppointmentTypesQueryVariables
>;
export const GetStaffDocument = gql`
  query GetStaff {
    getStaff {
      ...StaffRow
    }
  }
  ${StaffRowFragmentDoc}
`;

/**
 * __useGetStaffQuery__
 *
 * To run a query within a React component, call `useGetStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffQuery(
  baseOptions?: Apollo.QueryHookOptions<GetStaffQuery, GetStaffQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStaffQuery, GetStaffQueryVariables>(
    GetStaffDocument,
    options,
  );
}
export function useGetStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStaffQuery,
    GetStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStaffQuery, GetStaffQueryVariables>(
    GetStaffDocument,
    options,
  );
}
export type GetStaffQueryHookResult = ReturnType<typeof useGetStaffQuery>;
export type GetStaffLazyQueryHookResult = ReturnType<
  typeof useGetStaffLazyQuery
>;
export type GetStaffQueryResult = Apollo.QueryResult<
  GetStaffQuery,
  GetStaffQueryVariables
>;
export const GetPayRatesDocument = gql`
  query getPayRates($staffUuid: String) {
    getPayRates(filter: { staffUuid: $staffUuid }) {
      ...PayRateRow
    }
  }
  ${PayRateRowFragmentDoc}
`;

/**
 * __useGetPayRatesQuery__
 *
 * To run a query within a React component, call `useGetPayRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayRatesQuery({
 *   variables: {
 *      staffUuid: // value for 'staffUuid'
 *   },
 * });
 */
export function useGetPayRatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayRatesQuery,
    GetPayRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPayRatesQuery, GetPayRatesQueryVariables>(
    GetPayRatesDocument,
    options,
  );
}
export function useGetPayRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayRatesQuery,
    GetPayRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPayRatesQuery, GetPayRatesQueryVariables>(
    GetPayRatesDocument,
    options,
  );
}
export type GetPayRatesQueryHookResult = ReturnType<typeof useGetPayRatesQuery>;
export type GetPayRatesLazyQueryHookResult = ReturnType<
  typeof useGetPayRatesLazyQuery
>;
export type GetPayRatesQueryResult = Apollo.QueryResult<
  GetPayRatesQuery,
  GetPayRatesQueryVariables
>;
export const CreatePayRateDocument = gql`
  mutation CreatePayRate($input: CreatePayRateInput!) {
    createPayRate(createPayRateInput: $input) {
      uuid
    }
  }
`;
export type CreatePayRateMutationFn = Apollo.MutationFunction<
  CreatePayRateMutation,
  CreatePayRateMutationVariables
>;

/**
 * __useCreatePayRateMutation__
 *
 * To run a mutation, you first call `useCreatePayRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayRateMutation, { data, loading, error }] = useCreatePayRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePayRateMutation,
    CreatePayRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePayRateMutation,
    CreatePayRateMutationVariables
  >(CreatePayRateDocument, options);
}
export type CreatePayRateMutationHookResult = ReturnType<
  typeof useCreatePayRateMutation
>;
export type CreatePayRateMutationResult =
  Apollo.MutationResult<CreatePayRateMutation>;
export type CreatePayRateMutationOptions = Apollo.BaseMutationOptions<
  CreatePayRateMutation,
  CreatePayRateMutationVariables
>;
export const UpdatePayRateDocument = gql`
  mutation UpdatePayRate($uuid: String!, $input: UpdatePayRateInput!) {
    updatePayRate(uuid: $uuid, updatePayRateInput: $input) {
      uuid
    }
  }
`;
export type UpdatePayRateMutationFn = Apollo.MutationFunction<
  UpdatePayRateMutation,
  UpdatePayRateMutationVariables
>;

/**
 * __useUpdatePayRateMutation__
 *
 * To run a mutation, you first call `useUpdatePayRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayRateMutation, { data, loading, error }] = useUpdatePayRateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePayRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePayRateMutation,
    UpdatePayRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePayRateMutation,
    UpdatePayRateMutationVariables
  >(UpdatePayRateDocument, options);
}
export type UpdatePayRateMutationHookResult = ReturnType<
  typeof useUpdatePayRateMutation
>;
export type UpdatePayRateMutationResult =
  Apollo.MutationResult<UpdatePayRateMutation>;
export type UpdatePayRateMutationOptions = Apollo.BaseMutationOptions<
  UpdatePayRateMutation,
  UpdatePayRateMutationVariables
>;
export const DeletePayRateDocument = gql`
  mutation DeletePayRate($uuid: String!) {
    deletePayRate(uuid: $uuid) {
      uuid
    }
  }
`;
export type DeletePayRateMutationFn = Apollo.MutationFunction<
  DeletePayRateMutation,
  DeletePayRateMutationVariables
>;

/**
 * __useDeletePayRateMutation__
 *
 * To run a mutation, you first call `useDeletePayRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayRateMutation, { data, loading, error }] = useDeletePayRateMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeletePayRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePayRateMutation,
    DeletePayRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePayRateMutation,
    DeletePayRateMutationVariables
  >(DeletePayRateDocument, options);
}
export type DeletePayRateMutationHookResult = ReturnType<
  typeof useDeletePayRateMutation
>;
export type DeletePayRateMutationResult =
  Apollo.MutationResult<DeletePayRateMutation>;
export type DeletePayRateMutationOptions = Apollo.BaseMutationOptions<
  DeletePayRateMutation,
  DeletePayRateMutationVariables
>;
